import React from "react";

const QuestionNum = ({ questionNumber, testObject }) => {
  if (testObject?.testConfig?.questionInfo == "false") {
    return "";
  }
  return (
    <div className="question-sno blue-bold-question-no">
      Question Number : <span>{questionNumber}</span>
    </div>
  );
};

export default QuestionNum;